import script from "./SummaryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryComponent.vue?vue&type=script&setup=true&lang=js"

import "./SummaryComponent.vue?vue&type=style&index=0&id=ed5485bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed5485bc"]])

export default __exports__